import React from 'react';
import Button from '@atlaskit/button';
import { FormattedMessage } from '@atlassian/jira-intl';

export function MessageWithSupportLink(props: {
	message: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	href: string;
}): React.JSX.Element {
	const { message, href = '' } = props;

	return (
		<FormattedMessage
			{...message}
			values={{
				support_link: (chunks) => (
					<Button spacing="none" href={href} appearance="link">
						{chunks}
					</Button>
				),
			}}
		/>
	);
}
